/**
 * Login page
 */
import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import SocialButton from '../../Components/SocialButton';
import * as LoginService from '../../Services/LoginService';
import * as FormValidationService from '../../Services/FormValidationService';
import { Form, FormGroup, Label, Input, } from 'reactstrap';
import LoginPreviewPanel from '../../Components/LoginPreviewPanel';

class Login extends Component {


   // facebookAppId = '679943619011315';  // Dev facebook key
   facebookAppId = '351328215521843';   // Live facebook key

   // Dev google key
   // googleClientId = '231688632496-ggu8ob36vrtkonmf27ulens1cmu26bpf.apps.googleusercontent.com';
   //Live google key
   googleClientId = '380766611471-ffqetkribho0ep6hj9demf6gi9c5o5it.apps.googleusercontent.com';

   constructor(props) {
      super(props);
      this.state = {
         ip: '',
         loading: false,
         email: '',
         password: '',
         formErrors: { blankEmail: false, validEmail: false, blankPassword: false },
         rerenderSocialButton: false
      };
   }

   componentDidMount() {
      LoginService.getIpAddress().then(response => {
         let ip = response.data.ip;
         this.setState({
            ip: ip
         })
      })
   }

   /**
    * Function is use to set email input field changes
    */
   handleEmailChange = (event) => {
      let fieldValidationErrors = this.state.formErrors;
      fieldValidationErrors.blankEmail = false;
      fieldValidationErrors.validEmail = false;
      this.setState({
         email: event.target.value,
         formErrors: fieldValidationErrors
      });
   }

   /**
    * Function is use to set password input field changes
    */
   handlePasswordChange = (event) => {
      let fieldValidationErrors = this.state.formErrors;
      fieldValidationErrors.blankPassword = false;
      this.setState({
         password: event.target.value,
         formErrors: fieldValidationErrors
      });
   }

   /**
    * Function is to submit the login values and to login user
    */
   handleSubmit = (event) => {
      event.preventDefault();
      const { email, password } = this.state
      if (email !== '' && FormValidationService.validateEmail(email) && password !== '') {
         this.setState({ loading: true })
         let loginData = {
            username: email,
            password: password,
         }
         LoginService.loginUser(loginData).then(response => {
            this.setState({ loading: false })
            if (response && response.api_status === 1) {
               toast.success("Successfully logged in.");
               let data = response.data
               localStorage.setItem('isUserLoggedIn', true);
               localStorage.setItem('currentUser', JSON.stringify(data));
               let path = '/admin';
               let domain = window.location.hostname;
               setTimeout(() => {
                  window.location.href = window.location.protocol + "//" + domain + path;
               }, 1500)
            } else {
               toast.error("Username or password is incorrect.");
            }
         });
      } else {
         this.validateField();
      }
   }

   /**
    * Function is use to login user using their social profiles(facebook, google)
    */
   handleSocialLogin = (user) => {
      this.setState({ loading: true })
      var postData = {
         registered_with: user._provider,
         first_name: user._profile.firstName,
         last_name: user._profile.lastName ? user._profile.lastName : '',
         email: user._profile.email,
         package: 'Growth-Yearly',
         ip: this.state.ip
      }
      LoginService.loginUserWithSocialAccounts(postData).then(response => {
         this.setState({ loading: false })
         if (response && response.api_status === 1) {
            toast.success(response.message);
            if (response.message === "Successfully signed up.") {
               window.fbq('track', 'CompleteRegistration');
            }
            let data = response.data
            localStorage.setItem('isUserLoggedIn', true);
            localStorage.setItem('currentUser', JSON.stringify(data));
            let path = '/admin';
            let domain = window.location.hostname;
            setTimeout(() => {
               window.location.href = window.location.protocol + "//" + domain + path;
            }, 1500)
         } else {
            toast.error(response.message);
         }
      });
   }

   /**
    * Function is use for validate the fields.
    */
   async validateField() {
      const { email, password } = this.state;
      let fieldValidationErrors = this.state.formErrors;
      if (email === '') { fieldValidationErrors.blankEmail = true; }
      if (email !== '' && FormValidationService.validateEmail(email) === null) {
         fieldValidationErrors.validEmail = true;
      }
      if (password === '') { fieldValidationErrors.blankPassword = true; }
      await this.setState({
         formErrors: fieldValidationErrors
      });
   }

   /**
    * Function is use for handle the social login error case.
    */
   get socialLoginPorops() {
      return {
         onLoginFailure: this.socialLoginErrorCallback
      }
   }

   /**
    * Function is use for if get social login any error, re-render the render.
    */
   socialLoginErrorCallback = (err) => {
      this.setState({ rerenderSocialButton: true }, () => { this.setState({ rerenderSocialButton: false }) })
   }

   render() {
      const { email, password, formErrors, rerenderSocialButton, loading } = this.state;
      return (
         <>
            {
               loading ?
                  <div className="sh-loader-wrap d-flex justify-content-center align-items-center">
                     <Spinner className="sh-loader" color="primary" />
                  </div>
                  :
                  <div className="sh-login-wrapper">
                     <div className="logo-wrap">
                        <a href="/" className="d-inline-block">
                           <img alt="logo" className="logo" src={process.env.PUBLIC_URL + "/images/header-logo.png"} height="60" />
                        </a>
                     </div>
                     <LoginPreviewPanel />
                     <div className="sh-main-panel">
                        <div className="sh-panel-table">
                           <div className="sh-panel-table-cell">
                              <div className="d-flex align-items-center switch-wrap">
                                 <div className="res-logo">
                                    <a href="/" className="d-inline-block">
                                       <img alt="logo" src={process.env.PUBLIC_URL + "/images/saleshangry-logo.png"} height="50" />
                                    </a>
                                 </div>
                                 <div>
                                    <span className="fs-14 pr-3">Don’ t have an account? </span>
                                    <a href="/pricing" className="d-inline-block">
                                       <button className="btn rounded-btn primary-bdr-btn fs-14 text-space">get started</button>
                                    </a>
                                 </div>
                              </div>
                              <div className="mx-auto content-wrap">
                                 <div>
                                    <h4 className="font-normal">Sign in to SalesHangry.</h4>
                                    <p className="mb-5">Enter your details below.</p>
                                 </div>
                                 <Form>
                                    <FormGroup className="input-group-lg">
                                       <Label for="emailId" className="text-uppercase">email address</Label>
                                       <Input type="email" autoComplete="off" value={email} onChange={this.handleEmailChange} placeholder="Email" id="emailId" />
                                       <span>{formErrors.blankEmail && FormValidationService.emptyField()}</span>
                                       <span>{formErrors.validEmail && FormValidationService.emptyField('email')}</span>
                                    </FormGroup>
                                    <FormGroup className="input-group-lg">
                                       <div className="d-flex justify-content-between align-items-center">
                                          <Label for="password" className="text-uppercase">password</Label>
                                          <a className="fs-14 text-primary" href="/login/forgot">Forgot Password ?</a>
                                       </div>
                                       <Input type="password" autoComplete="off" value={password} onChange={this.handlePasswordChange} placeholder="Password" id="passwordId" />
                                       <span>{formErrors.blankPassword && FormValidationService.emptyField()}</span>
                                    </FormGroup>
                                    <div className="text-center mb-5 mt-4">
                                       <button
                                          className="btn btn-lg px-5 rounded-btn btn-primary fs-14 text-space"
                                          type="submit"
                                          onClick={this.handleSubmit}
                                       >
                                          login
                                 </button>
                                    </div>
                                 </Form>
                                 {
                                    !rerenderSocialButton &&
                                    <>
                                       <div className="social-icons-wrap mb-4 text-center">
                                          <SocialButton
                                             className="btn-primary btn-lg fs-14 btn ml-sm-0 mr-sm-4 btn-shadow mb-sm-0 mb-4 mx-3"
                                             provider='facebook'
                                             appId={this.facebookAppId}
                                             onLoginSuccess={this.handleSocialLogin}
                                             {...this.socialLoginPorops}
                                          >
                                             <img className="pr-3 d-inline-block" src={process.env.PUBLIC_URL + "/images/facebook-icon.png"} alt="icon" height="26" />
                                             Login With Facebook
                                    </SocialButton>
                                          <SocialButton
                                             className="light-bg btn-lg fs-14 btn btn-shadow mb-4 mb-sm-0 mx-sm-0 mx-3"
                                             provider='google'
                                             appId={this.googleClientId}
                                             onLoginSuccess={this.handleSocialLogin}
                                             {...this.socialLoginPorops}
                                          >
                                             <img className="pr-3 d-inline-block" alt="icon" src={process.env.PUBLIC_URL + "/images/google-icon.png"} height="26" />
                                             Login With Google
                                    </SocialButton>
                                       </div>
                                    </>
                                 }
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
            }

         </>
      );
   }
}

export default Login;
